module.exports = [
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt0 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30339001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30085001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt0 && duo-spout_opt2 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30080001"
				],
				"bundle": [
					"40841001"
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30327DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt0 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30325DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt0 && tap_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31498000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt0 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31498DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt0 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31454DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt2 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31455DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt0"
		],
		"groups": [
			{
				"products": [
					"31456000"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt1 && tap_opt1 && duo-spout_opt1 && finish_opt1"
		],
		"groups": [
			{
				"products": [
					"31456DC0"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt0"
		],
		"groups": [
			{
				"products": [
					"31454000",
					"30339001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30085001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt0 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"31455000",
					"30080001",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt0 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079001",
					"31498000",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt0"
		],
		"groups": [
			{
				"products": [
					"30083DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	},
	{
		"conditions": [
			"location_opt1 && water-type_opt2 && main-faucet_opt1 && duo-spout_opt2 && finish_opt1 && boiler_opt1"
		],
		"groups": [
			{
				"products": [
					"30079DC1",
					"31498DC0",
					"40841001"
				],
				"bundle": [
					""
				]
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/water_conditions_pl_pl.json
// module id = 856
// module chunks = 0